var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPodcast56 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M28.5 5.999a22.5 22.5 0 0 0-11.473 41.855.5.5 0 0 0 .51-.86 21.5 21.5 0 1 1 21.926 0 .5.5 0 1 0 .51.86A22.5 22.5 0 0 0 28.5 6Zm0 7.978a14.5 14.5 0 0 0-11.72 23.038.5.5 0 0 0 .81-.588 13.5 13.5 0 1 1 21.82 0 .5.5 0 1 0 .81.588A14.498 14.498 0 0 0 28.5 13.977Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M25 26.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm3.5-4.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm-3.117 14.289A3.5 3.5 0 0 1 26.776 36h3.448a3.5 3.5 0 0 1 3.493 3.733L33.033 50h-9.065l-.685-10.267a3.502 3.502 0 0 1 2.1-3.444Zm6.632-.918a4.5 4.5 0 0 0-1.79-.371h-3.449a4.5 4.5 0 0 0-4.49 4.8L23 50.532a.5.5 0 0 0 .5.467h10a.5.5 0 0 0 .498-.467l.716-10.734a4.498 4.498 0 0 0-2.7-4.428Z",
  clipRule: "evenodd"
})));
export { SvgPodcast56 as ReactComponent };
export default __webpack_public_path__ + "d63cb459e495cd6511b5288db88b6e00.svg";